import { typedStorage } from 'utils/storage';

export const LANG_CONFIG = {
  es: {
    img: '/images/spain.png',
  },

  en: {
    img: '/images/us.png',
  },

  'pt-BR': {
    img: '/images/br.png',
  },
} as Record<string, { img: string }>;

export const langStore = typedStorage<{ lang: string }>().init({
  lang: {
    key: '2309849023',
    storage: 'session',
    validate: (value) => !!LANG_CONFIG[value],
  },
});
